import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  { q: "A IA realmente entende o que o cliente escreve?", a: "Sim. Ela foi treinada pra conversar do jeito que cliente de restaurante escreve mesmo: abreviação, erro de digitação, áudio transcrito. Se ela ficar em dúvida em algum pedido, ela pergunta antes de confirmar — e você sempre pode assumir a conversa quando quiser." },
  { q: "Preciso de computador ou equipamento especial?", a: "Não. O sistema funciona no celular, tablet ou computador que você já tem. A impressão automática funciona com as impressoras térmicas comuns, as mesmas usadas pra cupom." },
  { q: "Quanto tempo leva pra começar a usar?", a: "Na maioria dos casos, o cardápio fica no ar no mesmo dia. Você cadastra os produtos (ou manda pra gente cadastrar), imprime o QR code e pronto. Nosso time acompanha os primeiros dias com você." },
  { q: "Tem fidelidade ou taxa por pedido?", a: "Não tem nenhuma das duas. Você paga só a mensalidade fixa do plano, pode cancelar quando quiser e todos os pedidos são seus — sem comissão como nos aplicativos de delivery." },
  { q: "Meus funcionários vão conseguir usar?", a: "Esse é o ponto forte do Pede é Fácil: a tela é simples, com botão grande e linguagem direta. Quem usa WhatsApp consegue usar o sistema. E qualquer dúvida, o suporte responde rápido, em português, por WhatsApp." },
  { q: "E se a internet cair?", a: "Os pedidos feitos pelo cliente ficam guardados e entram no painel assim que a conexão volta. Você também pode lançar pedidos manualmente pelo celular usando os dados móveis." },
];

const FaqItem = ({ q, a, isOpen, onToggle, idx }) => (
  <div data-testid={`faq-item-${idx}`} className={`border-[3px] border-brutal-black ${isOpen ? "bg-brutal-yellow shadow-brutal-md" : "bg-white shadow-brutal-sm"} transition-all`}>
    <button onClick={onToggle} className="w-full px-5 sm:px-6 py-5 flex items-center justify-between gap-4 text-left">
      <span className="font-heading text-base sm:text-lg text-brutal-black uppercase leading-tight">{q}</span>
      <span className={`shrink-0 inline-flex items-center justify-center w-9 h-9 border-[2.5px] border-brutal-black shadow-brutal-xs ${isOpen ? "bg-brutal-pink rotate-180" : "bg-brutal-lime"} transition-transform`}>
        {isOpen ? <Minus size={18} strokeWidth={3} className="text-brutal-black" /> : <Plus size={18} strokeWidth={3} className="text-brutal-black" />}
      </span>
    </button>
    {isOpen && (
      <div className="px-5 sm:px-6 pb-5 border-t-[2.5px] border-brutal-black border-dashed">
        <p className="mt-4 text-brutal-black font-medium leading-relaxed text-sm sm:text-base">{a}</p>
      </div>
    )}
  </div>
);

export const Faq = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section id="faq" data-testid="faq" className="py-24 sm:py-32 bg-brutal-cream">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="inline-flex items-center gap-2 bg-brutal-pink border-[2.5px] border-brutal-black px-3.5 py-1.5 shadow-brutal-xs">
          <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-white">? DÚVIDAS FREQUENTES</span>
        </div>
        <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brutal-black uppercase leading-[0.95]">
          Ficou alguma<br />
          <span className="bg-brutal-yellow border-[3px] border-brutal-black px-3 inline-block shadow-brutal -rotate-1 mt-2">dúvida?</span>
        </h2>
        <div className="mt-10 space-y-4">
          {faqs.map((f, i) => (
            <FaqItem key={i} idx={i} q={f.q} a={f.a} isOpen={openIdx === i} onToggle={() => setOpenIdx(openIdx === i ? -1 : i)} />
          ))}
        </div>
      </div>
    </section>
  );
};
